import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.fixedScrollTo($(window));
		Vegas.fixedHeader($(window));
		Vegas.tooltip();
		Vegas.popover();
		Vegas.scrollToElement();
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},

	onResize: ($self) => {
		//Vegas.carousel();
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		if (!$('body').hasClass('vg-page-static')) {
			$('[data-scrollTo="spy"]').find('a').each(function () {
				let link = $(this).attr('href');

				if (link.indexOf('/#') !== -1) {
					$(this).attr('href', link.slice(1));
				}
			});
		}

		// navigation
		new VGNav({
			expand: 'lg',
			toggle: '<i class="fal fa-chevron-down"></i>'
		}, {
			afterInit: function () {
				if (!$('body').hasClass('vg-page-static')) {
					let $vgScrollTo = $('[data-scrollTo="spy"]');

					$vgScrollTo.vgScrollToSpy({
						spy: true
					})
				}
			},
			afterClick: function () {
				$('.vg-nav-hamburger, .vg-nav-sidebar, .vg-nav-overlay').removeClass('show');
				$('body').removeClass('vg-nav-sidebar-open');
			}
		});

		// animation
		AOS.init({
			once: true,
		});

		// nice select
		$('.nice-select').niceSelect();

		// scroll
		$('[data-scrollTo]').vgScrollToSpy();

		// fancybox remove zoom image
		fancybox.Fancybox.bind("[data-fancybox]", {
			Image: {
				zoom: false,
			},
		});

		// VGLawCookie
		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	popover: function() {
		let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function (popoverTriggerEl) {
			return new bootstrap.Popover(popoverTriggerEl, {
				html: true,
				container: 'body',
			})
		});
	},

	tooltip: function () {
		let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new bootstrap.Tooltip(tooltipTriggerEl, {
				trigger: 'hover'
			})
		})
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-striped');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			// AOS
			if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
				let $tags = ['p', 'li', 'h2', 'h3'],
					start = parseInt($self.data('aos-start')),
					step = 100;

				for (let i = 1; i <= $tags.length; i++) {
					let tag = $tags[i - 1],
						$tag = $self.find(tag);

					if ($tag.length) {
						$.each($tag, function () {
							start = start + step;
							$(this).attr('data-aos', 'fade-up');
							$(this).attr('data-aos-delay', start);
						});
					}
				}

				AOS.init();
			}
		});
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	fixedHeader: function ($self) {
		let $sticky = $('.vg-header-wrapper'),
			scroll = $self.scrollTop(),
			scroll_offset = $sticky.height(),
			offset = $sticky.height(),
			$body = $('body');

		if (scroll > 0) {
			$body.addClass('vg-header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('vg-header--is-fixed');
		}

		if ($body.hasClass('vg-header--is-fixed')) {
			$('.vg-widgets-sticky, .vg-sticky').css('top', offset + 10);
			$('.vg-vacancies-item--header').css('top', offset);
		} else {
			$('.vg-widgets-sticky, .vg-sticky').css('top', 10);
			$('.vg-vacancies-item--header').css('top', 0);
		}
	},

	scrollToElement: function () {
		let hash = location.hash.slice(1);

		if (hash) {
			let $el = $('#' + hash);
			if ($el.length) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $el.offset().top - 100
				}, 400);
			}
		}

		$('[data-scrollto]').click(function() {
			let href = $(this).attr('href');
			if (href.indexOf('#') !== 0) {
				href = '#' + href;
			}
			let $el = $(href);
			if ($el.length) {
				$([document.documentElement, document.body]).animate({
					scrollTop: $el.offset().top - ($(this).data('offset') || 100)
				}, 400);
			}
		})
	},
};
